export default "__VITE_ASSET__DX3tAGrq__"